export const DAY_DATE_FORMAT = "dddd";
export const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";
export const ISO_DATE_FORMAT = "YYYY-MM-DD";
export const DAY_DEFAULT_DATE_FORMAT = `${DAY_DATE_FORMAT} ${DEFAULT_DATE_FORMAT}`;
